module.exports = __webpack_public_path__ + "static/bio-illus-93fff26b09bf38d2e0079fe002e2972c.png";